import alert from './alert';
import operations from './operations';
import at from './at';
import inventory from './inventory';

const routes = [
  {
    path: '/',
    meta: {
      authorization: {
        authenticated: true,
      },
    },
    component: () => import('@/views/layouts/DynamicLayout.vue'),
    children: [
      {
        path: '/',
        name: 'dashboard',
        component: () => import('@/views/Dashboard.vue'),
      },
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/home/Menu.vue'),
      },
      ...alert,
      ...operations,
      ...at,
      ...inventory,
    ],
  },
];

export default routes;
